<template>
  <b-sidebar
    v-model="activSide"
    width="450px"
    class="mx-1"
    id="edit-sidebar"
    shadow
    bg-variant="white"
    backdrop
  >
    <validation-observer ref="newsValidation">
      <b-form class="auth-login-form px-2" @submit.prevent="formSubmitCreate">
        <b-row>
          <b-col cols="12" v-for="(item, i) in newsFormSchema" :key="i">
            <component
              v-if="item.component"
              :is="item.component"
              v-bind="item.attrs"
              v-on="item.listeners"
              v-model="form[item.key]"
            ></component>
          </b-col>
          <b-col cols="12">
            <!-- <form-file
              label="صورة الخبر"
              id="form-image"
              name="image"
              v-model="image"
              @change="previewImage"
            />
            <div class="border rounded-lg text-center mb-1">
              <img
                v-if="localImage"
                :src="localImage"
                class="img-fluid rounded-lg"
                id="preview"
              />
              <feather-icon v-else icon="ImageIcon" class="my-3" size="30" />
            </div> -->
            <form-image-input
              label="صورة الخبر"
              id="form-image"
              name="image"
              v-model="form.image"
              withCropper
              :cropAspectRatio="16 / 9"
            />

            <form-file
              label="الفيديو"
              accept="video/mp4,video/x-m4v,video/*"
              id="form-Video"
              placeholder="اختر فيديو"
              name="image"
              v-model="video"
              @change="previewVideo"
            />

            <div
              v-if="video !== null"
              class="d-flex justify-content-between shadow align-items-center my-1 p-1"
            >
              <!-- <span>
            {{ item.name.length > 30 ? `${item.name.slice(0,30)}...` : item.name}}
          </span> -->
              <div>
                <feather-icon size="15" icon="VideoIcon" />
              </div>
              <b-button
                @click="deleteVideo()"
                variant="flat-danger"
                class="btn-icon rounded-circle"
              >
                <feather-icon size="15" icon="Trash2Icon" />
              </b-button>
            </div>
            <form-file
              label="معرض الصور"
              accept="image/*"
              id="form-slide"
              placeholder="اختر صور"
              name="image"
              @change="previewSlide"
              multiple
            />
            <div
              class="d-flex justify-content-between shadow align-items-center my-1"
              v-for="(item, i) in imageSlide"
              :key="i"
            >
              <b-img
                :src="item.url"
                fluid-grow
                style="width: 50px !important; height: 50px"
                class="m-1 rounded"
              />
              <span>
                {{
                  item.name.length > 30
                    ? `${item.name.slice(0, 30)}...`
                    : item.name
                }}
              </span>
              <b-button
                @click="deleteImage(i)"
                variant="flat-danger"
                class="btn-icon rounded-circle"
              >
                <feather-icon size="15" icon="Trash2Icon" />
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-col class="justify-content-end d-flex pt-50 align-items-center">
          <b-button
            @click="activSide = false"
            variant="outline-secondary"
            class=""
          >
            <feather-icon icon="XIcon" />
            إلغاء
          </b-button>
          <save-btn
            class="ml-1"
            variant="primary"
            style="height: 40px"
            type="submit"
            :loading="loadingSubmit"
          >
          </save-btn>
        </b-col>
      </b-form>
    </validation-observer>
  </b-sidebar>
</template>

<script>
import saveBtn from "@/components/loader-btn";
import FormFile from "@/components/form-file/index.vue";

import {
  BSidebar,
  BRow,
  BCol,
  BForm,
  BImg,
  BButton,
  BFormFile,
} from "bootstrap-vue";
import FormInput from "@/components/form-input";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import FormMask from "@/components/form-mask/index.vue";
import FormSelect from "@/components/form-select";
import FormTextarea from "@/components/form-textarea/index.vue";
import FormAutocomplete from "@/components/form-autocomplete";
import { mapGetters } from "vuex";
import FormDatepicker from "@/components/form-datepicker/index.vue";

import FormImageInput from "@/components/FormImageInput.vue";
export default {
  props: {
    value: Boolean,
    newsFormSchema: Object,
    type: String,
  },
  components: {
    BSidebar,
    FormInput,
    BRow,
    BCol,
    BForm,
    FormMask,
    ValidationObserver,
    ValidationProvider,
    FormSelect,
    FormTextarea,
    BImg,
    FormAutocomplete,
    BButton,
    BFormFile,
    saveBtn,
    FormFile,
    FormDatepicker,
    FormImageInput,
  },
  data: () => {
    return {
      form: {},
      videoSubmit: null,
      imageSubmit: null,
      video: null,
      image: null,
      localImage: null,
      imageSlide: [],
      imageSlideSubmit: [],
    };
  },
  methods: {
    previewVideo(event) {
      this.video = event.target.files[0];
    },

    previewSlide(event) {
      // let arrayToSend =[]
      this.imageSlideSubmit = event.target.files;
      this.imageSlide = Array.from(event.target.files).map((file) => ({
        url: URL.createObjectURL(file),
        name: file.name,
      }));

      // this.imageSlide.push(...arrayToSend)
    },

    async formSubmitCreate() {
      this.$refs.newsValidation.validate().then(async (success) => {
        if (success) {
          await this.AddNews();
        }
      });
    },
    init() {
      const newObjact = {
        title_ar: this.detailsNews.title_ar,
        description_ar: this.detailsNews.description_ar,
        image: this.detailsNews.image,
        slides: this.detailsNews.slides,
        accomplished_at_date: this.detailsNews.accomplished_at_date,
        accomplished_at_time: this.detailsNews.accomplished_at_time,
        governorate_id: this.detailsNews.governorate
          ? this.detailsNews.governorate.id
          : null,
        area_id: this.detailsNews.area ? this.detailsNews.area.id : null,
      };
      this.form = JSON.parse(JSON.stringify(newObjact));
    },

    deleteImage(index) {
      this.imageSlide.splice(index, 1);
      this.imageSlideSubmit.splice(index, 1);
    },
    deleteVideo() {
      this.video = null;
      this.videoSubmit = null;
    },

    async AddNews() {
      if (this.type == "ADD") {
        const fd = new FormData();
        fd.append("title_ar", this.form.title_ar);
        fd.append("description_ar", this.form.description_ar);
        fd.append("image", this.form.image);
        if (this.video) fd.append("video", this.video);
        if (this.imageSlideSubmit.length)
          for (let i = 0; i <= this.imageSlideSubmit.length; i++) {
            fd.append("slides[]", this.imageSlideSubmit[i]);
          }
        fd.append("accomplished_at_date", this.form.accomplished_at_date);
        fd.append("accomplished_at_time", this.form.accomplished_at_time);
        fd.append("governorate_id", this.form.governorate_id);
        fd.append("area_id", this.form.area_id);

        await this.$store
          .dispatch("manageInterfaceNgo/NewsManagement/createNews", {
            fd: fd,
          })
          .then(() => {
            this.activSide = false;
            this.$store.dispatch("manageInterfaceNgo/NewsManagement/getNews", {
              page: this.currentPage,
            });
          });
      } else {
        const fd = new FormData();
        fd.append("_method", "PUT");
        fd.append("title_ar", this.form.title_ar);
        fd.append("description_ar", this.form.description_ar);
        if (typeof this.form.image !== "string") {
          fd.append("image", this.form.image);
        }
        if (this.video) {
          fd.append("video", this.video);
        }
        if (this.imageSlideSubmit.length) {
          for (let i = 0; i <= this.imageSlideSubmit.length; i++) {
            fd.append("slides[]", this.imageSlideSubmit[i]);
          }
        }

        fd.append("accomplished_at_date", this.form.accomplished_at_date);
        fd.append("accomplished_at_time", this.form.accomplished_at_time);
        fd.append("governorate_id", this.form.governorate_id);
        fd.append("area_id", this.form.area_id);

        await this.$store
          .dispatch("manageInterfaceNgo/NewsManagement/updateNews", {
            id: this.detailsNews.id,
            fd: fd,
            id_news: this.detailsNews.id,
          })
          .then(() => {
            this.activSide = false;
          });
      }
    },
  },

  watch: {
    detailsNews(val) {
      if (this.type != "ADD") {
        this.init();
      }
    },

    activSide(val) {
      if (this.type == "ADD") {
        this.form = {};
        this.videoSubmit = null;
        this.imageSubmit = null;
        this.video = null;
        this.image = null;
        this.imageSlide = [];
        this.imageSlideSubmit = [];
      }
    },
  },
  computed: {
    activSide: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    ...mapGetters("manageInterfaceNgo/NewsManagement", [
      "detailsNews",
      "loadingDetails",
      "loadingSubmit",
    ]),
    upLoadeimage() {
      return this.image || this.detailsNews.image;
    },
  },

  created() {
    if (this.type === "ADD") {
      this.form = {};
      this.videoSubmit = null;
      this.imageSubmit = null;
      this.video = null;
      this.image = null;
      this.imageSlide = [];
      this.imageSlideSubmit = [];
    }
  },
};
</script>

<style lang="scss">
.uploadeFill {
  width: 100%;
  position: absolute;
  top: 20px;
  z-index: 10;
  height: 130px;
  cursor: pointer;
  display: flex;
  justify-content: center;
}
.validation_image {
  position: relative;
  top: -20px;
}
</style>
